import { Skeleton } from '@mui/material'
import url from 'libraries/front-end-core/core/url'
import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import useObservable from 'libraries/front-end-core/hooks/useObservable'
import { DOCUMENTS_REVIEW, SHARE } from 'constants/controllers'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import ShareLink from './ShareLink'
import EmailLink from './EmailLink'
import CopyButton from './CopyButton'
import { requestShorten } from 'helpers/shorty'

export default function ShareLinks ({
  sectionId,
  selectedIds
}: {
  sectionId: string
  selectedIds: string[]
}): JSX.Element {
  const data = useObservable(
    requestShorten(
      url(DOCUMENTS_REVIEW, { sectionId, documentIds: selectedIds })
    ),
    RESPONSE_PENDING
  )

  return (
    <div className='w11-half flex justify-between items-center mh0-t mh6 precedents-blue'>
      <ResponseConsumer
        response={data}
        content={() => {
          const shareUrl = url(SHARE, { short: data.short }, {}, true)

          return (
            <>
              <EmailLink shareUrl={shareUrl} />
              <CopyButton shareUrl={shareUrl} />
              <ShareLink shareUrl={shareUrl} />
            </>
          )
        }}
        pendingComponent={() => (
          <>
            <Skeleton variant='rectangular' className='hs8 w8 br2' />
            <Skeleton variant='rectangular' className='hs8 w8 br2' />
            <Skeleton variant='rectangular' className='hs8 w8 br2' />
          </>
        )}
      />
    </div>
  )
}
